import React from "react"
import Image from "next/image"
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
  DotGroup,
  Dot,
} from "pure-react-carousel"
import "pure-react-carousel/dist/react-carousel.es.css"
import { StarIcon, ChevronRightIcon, ChevronLeftIcon } from "@heroicons/react/20/solid"

export function CarouselTestimonials({ title, description, testimonials }) {
  return (
    <div className="bg-white py-12">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto text-center">
          <h2 className="text-4xl font-semibold tracking-tight text-balance text-gray-900 sm:text-5xl">
            {title}
          </h2>
          <p className="mt-4 text-lg font-medium text-pretty sm:text-xl/8">{description}</p>
        </div>

        {/* Testimonials */}
        <div className="mt-8">
          <CarouselProvider
            naturalSlideWidth={1}
            isIntrinsicHeight="true"
            totalSlides={3}
            infinite="true"
          >
            {/* Previous Button */}
            <ButtonBack className="absolute top-1/2 left-0 z-10 -translate-y-1/2 transform">
              <ChevronLeftIcon className="h-12 w-12 text-black" aria-hidden="true" />
            </ButtonBack>

            {/* Testimonial */}
            <Slider>
              {testimonials.map((testimonial, index) => (
                <Slide key={index}>
                  <section className="bg-white">
                    <figure className="mx-auto grid max-w-7xl grid-cols-1 lg:grid-cols-2">
                      <div className="col-span-1 p-8 lg:p-4">
                        <Image
                          layout="fill"
                          alt="test"
                          src={testimonial.image}
                          className="relative! rounded-3xl drop-shadow-lg"
                        />
                      </div>
                      <div className="col-span-1 p-8 lg:p-8">
                        <p className="sr-only">5 out of 5 stars</p>
                        <div className="flex gap-x-1 text-slate-900">
                          <StarIcon aria-hidden="true" className="size-5 flex-none" />
                          <StarIcon aria-hidden="true" className="size-5 flex-none" />
                          <StarIcon aria-hidden="true" className="size-5 flex-none" />
                          <StarIcon aria-hidden="true" className="size-5 flex-none" />
                          <StarIcon aria-hidden="true" className="size-5 flex-none" />
                        </div>
                        <blockquote className="mt-10 text-xl/8 font-semibold tracking-tight text-gray-900 sm:text-2xl/9">
                          <p>{testimonial.review}</p>
                        </blockquote>
                        <figcaption className="mt-10 flex items-center gap-x-6">
                          <div className="text-md/6">
                            <div className="font-semibold text-gray-900">- {testimonial.name}</div>
                          </div>
                        </figcaption>
                      </div>
                    </figure>
                  </section>
                </Slide>
              ))}
            </Slider>

            {/* Next Button */}
            <ButtonNext className="absolute top-1/2 right-0 z-10 -translate-y-1/2 transform">
              <ChevronRightIcon className="h-12 w-12 text-black" aria-hidden="true" />
            </ButtonNext>

            {/* Dots */}
            <div className="mx-auto mt-4 text-center">
              <DotGroup />
            </div>
          </CarouselProvider>
        </div>
      </div>
    </div>
  )
}
